import React from 'react';
import unpick from '../../../utilities/unpick';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import reformatValue from '../../utilities/reformat-value';
import InputMaskWrap from './input-mask-wrapper';

export default function Textarea(props) {
  const { isValid, onChange, mask, replacePattern } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'replacePattern']);

  const eventProps = replacePattern ? {
    onChange(e) {
      bubbleUpEvents(e, [
        reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr),
        onChange
      ]);
    }
  } : '';

  const inputField = (
    <textarea
      {...p}
      {...eventProps}
      aria-label={props.ariaLabel || 'Textarea'}
      aria-placeholder={props.placeholder || ''}
      aria-multiline="true"
      aria-invalid={!isValid}
      inputMode="text"
    />
  );

  return mask ? <InputMaskWrap>{inputField}</InputMaskWrap> : inputField;
}

Textarea.propTypes = {};
